import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsAdminPreferencesPage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="admin-preferences"
    />
  );
}
